module.exports = __webpack_public_path__ + "img/brighton_oak_bfusa_list.55ff5639.jpg";